import { dataMinimize } from 'dls-icons-data'
import { createIcon } from '../common'

const IconMinimize = /*#__PURE__*/createIcon(dataMinimize)
export default IconMinimize
